/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';
import { SalesforceReportObject } from './types';

interface State {
  readonly data?: SalesforceReportObject[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: (folderID: string, orgID: string) => Promise<void>;
}

export default function useDataAPIGetSalesforceReportsByOrgIDAndFolderID(
  folderID?: string,
  orgID?: string
): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(folderID: string, orgID: string): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getSalesforceReportsByOrgIDAndFolderID(
        folderID,
        orgID
      );

      setState({ data, isLoading: false });
    } catch (error: any) {
      setState({ error, isLoading: false });
    }
  }

  useEffect(() => {
    if (!orgID || !folderID) return;

    fetch(folderID, orgID);
  }, [orgID, folderID]);

  return { ...state, refetch: fetch };
}
